import Cookies from 'js-cookie'
import { ErrorHandlerService } from '@loavies/utils'

/**
 * TODO: Replace with model
 * https://loavies.atlassian.net/browse/C2C-97
 * @typedef {Object} TokenDetails
 * @property {string} access_token
 * @property {number} expires_in
 * @property {string} refresh_token
 * @property {string} scope
 * @property {string} token_type
 */

export class MarketplaceAuthenticationService {
  constructor(marketplaceService) {
    this.marketplaceService = marketplaceService
    this.marketplace = marketplaceService.instance
    this.errorHandlerService = new ErrorHandlerService()
    this.cookieKey = 'st-' + this.marketplaceService.clientId + '-token'
  }

  /**
   * https://www.sharetribe.com/api-reference/marketplace.html#logging-in
   * @param {loavies.models.user.LoginUserModel} loginUserModel
   * @return {Promise}
   */
  login(loginUserModel) {
    return this.marketplace.login(loginUserModel)
  }

  /**
   * https://www.sharetribe.com/api-reference/marketplace.html#logging-out
   * @return {Promise}
   */
  logout() {
    return this.marketplace.logout()
  }

  /**
   * @return {undefined|TokenDetails}
   */
  getTokenDetails() {
    // CHECK IN COOKIES
    const cookieValue = Cookies.get(this.cookieKey)

    if (cookieValue) {
      try {
        return JSON.parse(cookieValue)
      } catch (error) {
        return undefined
      }
    }

    return undefined
  }


  /**
   * @param {Object} tokenDetails
   * @returns {void}
   */
  setTokenDetails(tokenDetails) {
    try {
      const jsonString = JSON.stringify(tokenDetails)
      Cookies.set(this.cookieKey, jsonString, { expires: 365 })
    } catch (error) {
      console.error(error)
    }
  }

  /**
   * @return {Object} authInfo
   */
  authInfo() {
    return this.marketplace.authInfo()
  }

  /**
   * @return {Promise}
   */
  refreshToken() {
    return this.marketplace.currentUser.show()
  }
}
